import { render } from "./IssueDetails.vue?vue&type=template&id=56c8742e&scoped=true"
import script from "./IssueDetails.vue?vue&type=script&lang=js"
export * from "./IssueDetails.vue?vue&type=script&lang=js"

import "./IssueDetails.vue?vue&type=style&index=0&id=56c8742e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src818063794/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c8742e"]])

export default __exports__